import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FeUtil, API } from '../../../hezky-routes';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class UsersService {
  constructor(public readonly feUtil: FeUtil) { }

  getAllUserByLocation(payload?: any): Observable<any> {
    return this.feUtil.httpSvc.get<any>(API.USER.GET_ALL_USER, payload || {})
  }
  
  getAllUserByCustomer(): Observable<any> {
    return this.feUtil.httpSvc.get<any>(API.USER.GET_ALL_USER)
  }

  getRoles(): Observable<any> {
    return this.feUtil.httpSvc.get<any>(API.USER.GET_ROLES)
  }

  getUserById(data: any): Observable<any> {
    return this.feUtil.httpSvc.get<any>(API.USER.GET_BY_ID + data.user_id)
  }

  addUser(data: any): Observable<any> {
    if (data instanceof FormData) {
      return this.feUtil.httpSvc.postFile<any>(API.USER.CREATE, data)
    }
    return this.feUtil.httpSvc.post<any>(API.USER.CREATE, data)
  }

  updateUser(data: any, userId: string): Observable<any> {
    const url = `${API.USER.UPDATE}${userId}`;
    if (data instanceof FormData) {
      return this.feUtil.httpSvc.patchFile<any>(url, data)
    }
    return this.feUtil.httpSvc.patch<any>(url, data)
  }

  updatePassword(payload: any): Observable<any> {
    return this.feUtil.httpSvc.patch(API.USER.UPDATE_PASSWORD, payload)
  }
  
  whoAmI(): Observable<any> {
    return this.feUtil.httpSvc.get<any>(API.USER.GET_BY_ID + this.feUtil.user_data.user_id, {}, new HttpHeaders({ 'x-app-ids': this.feUtil.user_data.application_id.map((app: { id: number }) => app.id).join(',') }))
  }


  // * Helper Methods
  getUsersByLocAccess(): Promise<any[]> {
    const key = Array.isArray(this.feUtil.nLevelPayload.location_id)
      ? this.feUtil.nLevelPayload.location_id.join(',')
      : String(this.feUtil.nLevelPayload.location_id);
    return new Promise((resolve, reject) => {
      this.getAllUserByLocation({ location_id: key }).subscribe({
        next: ({ data, status }) => {
          if (status !== 200) return reject(data);
          resolve(data ?? []);
        },
        error: (err) => reject(err),
      });
    });
  }
}
